module.exports = __webpack_public_path__ + "3d714f5ffc3261234689b6b9bb1ca464.png";